import ProposalItemLoader from './ProposalItemLoader';
export default ProposalItemLoader;
